import { App } from 'antd';

/**
 * Thin wrapper over the antd `App.useApp()` message API with a 5 s default duration.
 * Must be used inside `<AntdApp>` (see App.tsx) so messages pick up the theme and locale.
 */
export default function useAppNotification() {
  const { message } = App.useApp();

  return {
    showErrorMessage: (content: string, duration: number = 5) => {
      message.error(content, duration);
    },
    showSuccessMessage: (content: string, duration: number = 5) => {
      message.success(content, duration);
    },
    showInfoMessage: (content: string, duration: number = 5) => {
      message.info(content, duration);
    },
    showWarningMessage: (content: string, duration: number = 5) => {
      message.warning(content, duration);
    },
    showLoadingMessage: (content: string, duration: number = 0) => {
      // duration 0 means it will persist until manually closed
      return message.loading(content, duration);
    }
  };
}
